<template>
    <div class="primary-service" ref="scroll">
        <div class="action-sheet" v-if="modalStatus">
            <div class="cover"></div>
            <div :class="{'open':sheetStatus,'simple':!attributeType,'complex':attributeType}">
                <div class="title">
                    <img :src="goodsInfo.thumb">
                    <span>{{goodsInfo.description}}</span>
                    <img class="close" src="../assets/images/popup_close@3x.png" @click="buyService()">
                </div>
                <div class="sheet-content">
                    <div class="sheet-scroll" v-if="attributeType">
                        <ul class="attribute">
                            <li class="items">
                                <span>基础检测费</span>
                                <ul class="details">
                                    <li class="active">基础检测费100元</li>
                                </ul>
                            </li>
                            <li class="items" v-for="(item,index) in properties" :key="item.id">
                                <span>{{item.name}}</span>
                                <ul class="details" :id="'complex'+index">
                                    <li :class="{'active':modules_values.indexOf(it.id)>-1}" v-for="(it) in item.values" 
                                    :key="it.id" @click="selectcomplexAttr(index,$event,it,item.name)">{{it.name}}</li>
                                </ul>
                            </li>
                        </ul>
                        <div class="desc">
                            <div class="desc-title">
                                <img src="../assets/images/global_explain@3x.png">
                                <span>标准说明</span>
                            </div>
                            <div class="text">
                                {{modules[0].property_description}}
                            </div>
                        </div>
                    </div>
                    <div class="sheet-scroll" v-if="!attributeType">
                        <div class="service-content">
                            <span class="tip">{{attributeTitle}}</span>
                            <ul class="service-category" id="simple">
                                <li :class="{'active':mid==item.id}" v-for="(item,index) in modules" 
                                :key="item.id" @click="selectSimpleAttr(index,item)">
                                    <span class="service-title">{{item.name}}</span>
                                    <div>
                                        <span>¥{{item.price}}</span>
                                        <div class="img"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="desc">
                            <div class="desc-title">
                                <img src="../assets/images/global_explain@3x.png">
                                <span>标准说明</span>
                            </div>
                            <div class="text">
                                {{description}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="footer-content" >
                        <div class="invoice">
                            <div class="sheet-price">
                                <span>合计：</span><span>¥{{total}}</span>
                            </div>
                        </div>
                        <div class="buy" @click="orderNow">立即支付</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-wrapper">
            <mt-header fixed title="购买服务" style="background:#3189FF;color:#ffffff;">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>

            <div class="scroll-wrapper">
                <div class="scroll-content">
                    <div class="goods-info grayBar">
                        <img :src="goodsInfo.thumb">
                        <div class="content">
                            <p>{{goodsInfo.description}}</p>
                                <span>¥</span><span>{{goodsInfo.e2}}</span><span></span><del>原价：¥{{goodsInfo.old_price}}</del>
                        </div>
                    </div>

                    <div id="box-wrapper">
                        
                    </div>

                    <mt-actionsheet
                        :actions="data"
                        v-model="sheetVisible">
                    </mt-actionsheet>

                    <div class="end-line" id="box">
                        —————&nbsp;&nbsp;到达页面底部，双击标题栏返回页顶&nbsp;&nbsp;—————
                    </div>
                </div>
            </div>
            
            

            <div class="footer">
                <div class="footer-content" >
                    <div class="invoice">
                        <div class="consultation" @click="openQiyu" v-if="allow_chat == 1">
                            <img src="../assets/images/global_footer_consult@3x.png">
                            <span>咨询</span>
                        </div>
                        <div class="text-des" @click="sa_m_invoice">
                            <span>可开具增值税发票</span>
                            <span>（支持电子或邮寄到付）</span>
                        </div>
                    </div>
                    <div class="buy" @click="buyService()">购买服务</div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.js'
import { Actionsheet } from 'mint-ui';
import _ from 'lodash'

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            gid: '',
            mid: '',
            modules_values: [],
            modules_tags: [],
            goodsInfo: {},
            scences: [],
            service_flow: [],
            questions: [],
            comments: [],
            engineers: [],
            message: [],
            engDom: {},
            animate: false,
            modalStatus: false,
            sheetStatus: false,
            attributeType: true,
            modules: [],
            properties: [],
            attributeTitle: '',
            scrollDom: {},
            description: '',
            standard_descs: [],

            broadcastComponent: {},
            engineersComponent: {},
            hotQuestionComponent: {},
            relatedGoodsComponent: {},
            commentComponent: {},
            serviceflowComponent: {},
            guaranteeComponent: {},
            boxWrapperComponent: {},

            data: [{
                name: '拍照',
                method : this.getCamera	// 调用methods中的函数
            }, {
                name: '从相册中选择', 
                method : this.getLibrary	// 调用methods中的函数
            }],
            sheetVisible: false,
            total: 0,
            allow_chat: 0,
            related_goods: [],
            app_id: window.config.appid
        }
    },
    mounted(){
        this.scrollDom = this.$refs.scroll
        this.scrollDom.addEventListener('scroll', this.watchScroll)
        let that = this

         this.boxWrapperComponent = Vue.extend({
            template: `<div id="box-wrapper">
            <div id="box1"></div>

            <div id="box2"></div>

            <div id="box3"></div>

            <div id="box4"></div>

            <div id="box5"></div>

            <div id="box6"></div>

            <div id="box7"></div>

            <div id="box8"></div>
        </div>`,
            data: function () {
                return {

                }
            }
        })

        this.sceneComponent = Vue.extend({
            template: `<div class="common-wrap scenario grayBar">
            <div class="title">
                <h2>适用场景</h2>（可点击相应场景查看具体说明）
            </div>
            <div class="scene-wrap">
                <ul class="list" v-if="scences.length<7">
                    <li v-for="(item,index) in scences" :key="item.id" @click="goScenePage(sence_url,goodsInfo.title+'适用场景说明',item.name)"
                        :class="index%6==0?'red':index%6==1?'green':index%6==2?'brown':index%6==3?'cyan':index%6==4?'blue':'yellow'"> 
                        <span>
                            {{item.name}}
                        </span>
                    </li>
                </ul>
                <ul class="more clearfix" v-if="scences.length>6">
                    <li v-for="(item,index) in scences" :key="item.id" @click="goScenePage(sence_url,goodsInfo.title+'适用场景说明')"
                        :class="index%6==0?'red':index%6==1?'green':index%6==2?'brown':index%6==3?'cyan':index%6==4?'blue':'yellow'"> 
                        <span>
                            {{item.name}}
                        </span>
                    </li>
                </ul>
            </div>
        </div>`,
            data: function () {
                return {
                    goodsInfo: that.goodsInfo,
                    scences: that.scences,
                    goArticle: that.goArticle,
                    sa_m_scene_element: that.sa_m_scene_element,
                    sence_url: window.config.API_URL1+'/apph5/page/use-case?app_id='+window.config.appid+'&gid=' + that.gid
                }
            },
            methods: {
                goScenePage(url,title,name){
                    that.sa_m_scene_element(that.goodsInfo.description,name)
                    that.goArticle(url,title)
                }
            }
        })

        this.broadcastComponent = Vue.extend({
            template: `<div class="common-wrap service-info grayBar">
            <div class="title">
                <h2>服务动态</h2>
            </div>
            <div class="marquee">
                <div class="marquee_box">
                    <ul class="marquee_list" :class="{marquee_top:animate}">
                        <li v-for="(item,index) in message" :key="index">
                            <div class="tag"></div>
                            <img :src="item.avatar">
                            <div class="content">
                                <div class="info">
                                    <span>{{item.uname}}</span>
                                    <span>{{item.display_time}}</span>
                                </div>
                                <span class="text">{{item.message}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>`,
            data: function () {
                return {
                    message: that.message,
                    animate: that.animate
                }
            }
        })

        this.engineersComponent = Vue.extend({
            template: `<div class="common-wrap engineers grayBar" ref="engs">
            <div class="title">
                <h2>在线工程师</h2>
            </div>
            <div class="engineer-wrap">
                <ul class="engineers-list clearfix" @click="goEngineers()">
                    <li v-for="item in engineers" :key="item.eng_no">
                        <div class="headurl"> 
                            <img :src="item.avatar_url">
                            <div v-show="item.status=='1'" class="tag" style="background:#25E266"></div>
                            <div v-show="item.status=='2'" class="tag" style="background:rgb(234, 78, 61)"></div>
                            <div v-show="item.status=='4'" class="tag" style="background:rgb(204, 204, 204)"></div>
                        </div>
                        <span v-show="item.status=='1'">在线</span>
                        <span v-show="item.status=='2'">忙碌</span>
                        <span v-show="item.status=='4'">离线</span>
                    </li>
                    <li v-show="engineers.length>=5">
                        <div class="headurl" style=""> 
                            更多
                            <div class="more_icon"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>`,
            data: function () {
                return {
                    engineers: that.engineers,
                    goodsInfo: that.goodsInfo
                }
            },
            methods: {
                goEngineers: that.goEngineers
            }
        })

        this.hotQuestionComponent = Vue.extend({
            template: `<div class="common-wrap hot-questions grayBar">
            <div class="title">
                <h2>热点问答</h2>
            </div>
            <ul class="question-list" ref="questions">
                <li v-for="(item,index) in questions" :key="item.id">
                    <div class="question-title">
                        <div>
                            <div id="imgUrl"></div>
                            <span>{{item.title}}</span>
                        </div>
                        <div class="downArrow" @click="changeOpenStatus(index)"></div>
                        <div class="upArrow" @click="changeOpenStatus(index)"></div>
                    </div>
                    <div class="content">
                        {{item.answer}}
                    </div>
                </li>
            </ul>
            <div class="more" @click="goArticle(uri,goodsInfo.title+'热点问题')">
                了解更多热点问答
            </div>
        </div>`,
            data: function () {
                return {
                    sa_m_hot_question: that.sa_m_hot_question,
                    goodsInfo: that.goodsInfo,
                    questions: that.questions,
                    uri: window.config.API_URL1+'/apph5/page/question?app_id='+window.config.appid+'&gid='+that.gid
                }
            },
            methods: {
                goArticle: that.goArticle,
                changeOpenStatus(index){
                    let questions = this.$refs.questions
                    let dom = questions.children[index]
                    if(dom.className == ''){
                        dom.className = 'open'
                        this.sa_m_hot_question(
                            this.goodsInfo.description,
                            this.questions[index].title
                        )
                    }else {
                        dom.className = ''
                    }
                }
            }
        })

        this.relatedGoodsComponent = Vue.extend({
            template: `<div class="common-wrap production grayBar">
            <div class="title">
                <h2>相关产品推荐</h2>
            </div>
            <div class="production-wrap">
                <ul class="production-list">
                    <li v-for="item in related_goods" :key="item.id" @click="getRelated_goods(item)">
                        <img :src="item.thumb">
                        <div class="des">
                            <span>{{item.title}}</span><br>
                            <span class="text">{{item.desc}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            
        </div>`,
            data: function () {
                return {
                    related_goods: that.related_goods
                }
            },
            methods: {
                getRelated_goods: that.getRelated_goods
            }
        })

        this.commentComponent = Vue.extend({
            template: `<div class="common-wrap evaluate grayBar">
            <div class="title">
                <h2>用户评价</h2>（每天采集自苹果官方最有价值评价10条数据）
            </div>
            <ul class="evaluate-list">
                <li v-for="item in comments" :key="item.id">
                    <div class="evaluate-title">
                        <span>
                            <p>{{item.title}}</p>
                            <div class="img"></div>
                        </span>
                        <span>{{item.nickname}}</span>
                    </div>
                    <div class="evaluate-content">
                        {{item.content}}
                    </div>
                </li>
            </ul>
        </div>`,
            data: function () {
                return {
                    comments: that.comments
                }
            }
        })

        this.serviceflowComponent = Vue.extend({
            template: `<div class="common-wrap progress grayBar">
            <div class="title">
                <h2>服务流程</h2>
            </div>

            <div class="flow"></div>

            <ul class="service-flow">
                <li v-for="item in service_flow" :key="item">
                    <img :src="item">
                </li>
            </ul>
        </div>`,
            data: function () {
                return {
                    service_flow: that.service_flow
                }
            }
        })

        this.guaranteeComponent = Vue.extend({
            template: `<div class="common-wrap double grayBar">
            <div class="title">
                <span>
                    <div class="img"></div>
                    <h2>双倍赔付承诺</h2>
                </span>
            </div>
            <div class="content">
                凡通过我们平台没能恢复成功，通过其他渠道成功恢复的，凭相关凭证，我们双倍退款，并免费赠送恢复软件一套。
            </div>
        </div>`,
            data: function () {
                return {
                    app_id: that.app_id,
                    primary_url: window.config.API_URL1+'/apph5/page/guarantee?app_id='+window.config.appid
                }
            },
            methods: {
                goArticle: that.goArticle
            }
        })
    },
    created(){
        localStorage.removeItem('primary_gid')
        localStorage.removeItem('primary_mid')
        localStorage.removeItem('primary_total')
        localStorage.removeItem('primary_tags')
        localStorage.removeItem('primary_modules')

        let  gid = this.$route.query.gid
        this.gid = gid?gid:localStorage.login_gid
        
        let allow_chat = this.$route.query.allow_chat
        this.allow_chat = allow_chat?allow_chat:localStorage.login_allow_chat

        this.getGoodsInfo()
    },
    methods:{
        getRelated_goods(data){
            this.sa_m_recommend_goods(data.title,this.goodsInfo.description)
            let info = {
                api_version: window.config.api_version,
                gid: data.id
            }
            this.$store.dispatch("getGoodsInfo",info).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    let service_type = result.res.data.ui_version
                    let goods = result.res.data.goods
                    if(service_type=='v1'){
                        this.$router.push({name:"purchase_service",query:{gid:data.id,allow_chat:goods.allow_chat}})
                    }else {
                        this.gid = data.id
                        this.allow_chat = goods.allow_chat
                        this.getGoodsInfo()
                    }
                }
            })
        },
        openQiyu(){
            this.sa_m_consult_button()
            var config = {
                uid: localStorage.kxuid,
                name: localStorage.nickname,
                mobile: localStorage.phone,
                success: function(){     // 成功回调
                    ysf.open();
                },
                error: function(){       // 错误回调
                    // handle error
                }
            };
            ysf.config(config);
        },
        goBack(){
            this.$router.go(-1)
        },
        orderNow(){
            this.sa_m_purchase_goods(
                this.goodsInfo.description,
                window.location.href
            )
            let tags = this.modules_tags.join('，')
            localStorage.primary_gid = this.gid
            localStorage.primary_mid = this.mid
            localStorage.primary_total = this.total
            localStorage.primary_tags = tags
            localStorage.primary_modules = this.modules_values
            
            if(this.attributeType){
                if(this.validToken('confirmV3','立即下单按钮')){ 
                    this.$router.push({name:'confirmV3',query:{gid:this.gid,total:this.total,tags:tags,modules:this.modules_values}})
                }
            }else {
                if(this.validToken('confirmOrder','立即下单按钮')){ 
                    this.$router.push({name:'confirmOrder',query:{mid:this.mid,gid:this.gid,modules:this.modules_values}})
                }
            }
        },
        selectSimpleAttr(index,data){
            this.mid = data.id
            this.total = data.price
            this.description = data.description
        },
        selectcomplexAttr(index,el,data,name){
            let values = this.properties[index].values
            for(let item of values){
                let i = this.modules_values.indexOf(item.id)
                if(i!=-1){
                    this.modules_values.splice(i,1)
                    this.modules_tags.splice(i,1)
                    this.total = this.total - parseFloat(item.price)
                }
            }          
            if(this.modules_values.indexOf(data.id)==-1){
                this.modules_values.push(data.id)
                this.modules_tags.push(name+'：'+data.name)
                this.total = this.total + parseFloat(data.price)
            }
        },
        goArticle(url,title){
            if(title == '双倍赔付承诺说明'){
                this.sa_m_click_promise_detail(window.location.href)
            }
            if(title == '微信热点问题'){
                this.sa_m_click_FAQ(this.goodsInfo.description)
            }
            this.$router.push({name:"article",query:{url:url,title:title}})
        },
        buyService(){
            let that = this
            if(this.modalStatus){
                setTimeout(function(){
                    that.modalStatus = false
                },500)
                that.sheetStatus = false
            }else {
                this.modalStatus = true
                setTimeout(function(){
                    that.sheetStatus = true
                },100)
            }
        },
        goEngineers(){
            this.$router.push({name:'engineerList',query:{gid:this.gid}})
        },
        watchScroll(){
            let target = document.querySelector('.engineers')
            let num = target.offsetTop - this.scrollDom.scrollTop -40
        },
        getServiceMessage(cb){
            let info = {
                api_version: window.config.api_version,
                gid: this.gid
            }
            let that = this;
            this.$store.dispatch("getServiceMessage",info).then((res)=>{
                this.message = res.data.res.data?res.data.res.data:[]
                cb()
                if(this.message.length>0){
                    setInterval(this.showMarquee, 4000)
                }
            })
        },
        showMarquee: function () {
            this.animate = true;
            setTimeout(()=>{
                let el
                el = this.message.shift();
                this.message.push(el);
                el = this.message.shift();
                this.message.push(el);
                this.animate = false;
            },500)
        },
        getGoodsInfo(){
            let info = {
                api_version: window.config.api_version,
                gid: this.gid
            }
            this.$store.dispatch("getGoodsInfo",info).then((res)=>{
                let data = res.data.res.data
                let extend = data.extend
                this.related_goods = extend.related_goods
                this.goodsInfo = data.goods
                
                this.scences = extend.scene
                this.service_flow = extend.service_flow
                this.questions = extend.hot_questions
                this.comments = extend.user_comments
                let engineers = extend.related_engineers?extend.related_engineers:[]
                if(engineers.length>5){
                    this.engineers = engineers.slice(0,5) 
                }else {
                    this.engineers = engineers
                }
                let ui_sort = data.ui_blocks
                let that = this

                new this.boxWrapperComponent().$mount('#box-wrapper')

                this.getServiceMessage(function(){
                    for(let i=1;i<=ui_sort.length;i++){
                        switch(ui_sort[i-1]){
                            case 'scene': new that.sceneComponent().$mount('#box'+i);break;
                            case 'service_broadcast': new that.broadcastComponent().$mount('#box'+i);break;
                            case 'related_engineers': new that.engineersComponent().$mount('#box'+i);break;
                            case 'hot_questions': new that.hotQuestionComponent().$mount('#box'+i);break;
                            case 'related_goods': new that.relatedGoodsComponent().$mount('#box'+i);break;
                            case 'user_comments': new that.commentComponent().$mount('#box'+i);break;
                            case 'service_flow': new that.serviceflowComponent().$mount('#box'+i);break;
                            case 'guarantee': new that.guaranteeComponent().$mount('#box'+i)
                        }
                    }
                })
                
                let len = data.groups[0].modules.length
                this.attributeType = len==1?true:false
                this.modules = data.groups[0].modules
                this.mid = this.modules[0].id
                if(this.attributeType){
                    this.total = this.modules[0].price
                    this.properties = this.modules[0].properties
                    let index = _.findIndex(this.properties,function(o){
                        return o.id == 6
                    })
                    this.properties.splice(index,1)
                    for(let item of this.properties){
                        this.modules_values.push(item.values[0].id)
                        this.modules_tags.push(item.name+'：'+item.values[0].name)
                    }
                }else {
                    this.attributeTitle = data.groups[0].title
                    this.total = this.modules[0].price
                    this.description = this.modules[0].description
                }
            })
        },
    },
    destroyed () {
        this.scrollDom.removeEventListener('scroll', this.watchScroll)
    },
    components:{
    }
}
</script>

<style lang="scss" scoped="" type="text/css">


</style>



// WEBPACK FOOTER //
// src/components/PrimaryService.vue